import { useState } from 'react';
import { Box, MenuItem, TextField } from '@mui/material';

export interface UsageDateRange { from: string; to: string; }

const PRESETS: { label: string; days: number }[] = [
  { label: 'Last 7 days', days: 7 },
  { label: 'Last 30 days', days: 30 },
  { label: 'Last 60 days', days: 60 },
];

const rangeForDays = (days: number): UsageDateRange => {
  const to = new Date();
  const from = new Date(to.getTime() - days * 24 * 60 * 60 * 1000);
  return { from: from.toISOString(), to: to.toISOString() };
};

// The range every usage view starts on.
export const defaultUsageRange = (): UsageDateRange => rangeForDays(30);

// A preset (7 / 30 / 60 days) plus a custom from/to range. Emits ISO { from, to }.
export const UsageDateFilter = ({ onChange }: { onChange: (range: UsageDateRange) => void }) => {
  const [preset, setPreset] = useState('30');
  const [customFrom, setCustomFrom] = useState('');
  const [customTo, setCustomTo] = useState('');

  const applyCustom = (fromDate: string, toDate: string) => {
    if (!fromDate || !toDate) return;
    onChange({
      from: new Date(`${fromDate}T00:00:00`).toISOString(),
      to: new Date(`${toDate}T23:59:59`).toISOString(),
    });
  };

  const changePreset = (value: string) => {
    setPreset(value);
    if (value !== 'custom') {
      onChange(rangeForDays(parseInt(value, 10)));
    } else {
      applyCustom(customFrom, customTo);
    }
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
      <TextField select size="small" label="Range" value={preset} onChange={(e) => changePreset(e.target.value)} sx={{ minWidth: 150 }}>
        {PRESETS.map(p => <MenuItem key={p.days} value={String(p.days)}>{p.label}</MenuItem>)}
        <MenuItem value="custom">Custom</MenuItem>
      </TextField>
      {preset === 'custom' && (
        <>
          <TextField size="small" type="date" label="From" InputLabelProps={{ shrink: true }} value={customFrom}
            onChange={(e) => { setCustomFrom(e.target.value); applyCustom(e.target.value, customTo); }} />
          <TextField size="small" type="date" label="To" InputLabelProps={{ shrink: true }} value={customTo}
            onChange={(e) => { setCustomTo(e.target.value); applyCustom(customFrom, e.target.value); }} />
        </>
      )}
    </Box>
  );
};
